/**
 * a user adds a trade plan during a time when we are not accepting tradeplans for that period.
 * So for example, the message below is saying the following: we don't accept trade plans for 
 * the market open period while the market is closed (let's say the night before). Please add the trade plan
 * after 7 am.
 * {
	"messageType": "alertNotification",
	"notificationId": 1645454497413,
	"notificationDetails": {"errorType":"TRADE_PLAN_ERROR","notificationType":"ERROR","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "INVALID_MARKET_PERIOD",
	"statusDetails": {"currentPeriod":"closed","desiredPeriod":"open","addTradePlanTime":"7am"},
	"date": "2022-02-21T09:41:38.246-0500",
	"timestamp": "1645454498246"
}

 * @param {*} statusDetails 
 * @returns an object that has 3 fields:
 * 1) currentPeriod: whats the current period? either (premarket, open, postmarket, closed)
 * 2) desiredPeriod: what period is the user trying to enter a trade plan for?
 * 3) addTradePlanTime: what time we do accept trade plans
 */
export function invalidMarketPeriodParser(statusDetails) {
  const parsedObj = {
    currentPeriod: null,
    desiredPeriod: null,
    addTradePlanTime: null,
  };
  if (statusDetails) {
    parsedObj.currentPeriod = statusDetails.currentPeriod ?? null;
    parsedObj.desiredPeriod = statusDetails.desiredPeriod ?? null;
    parsedObj.addTradePlanTime = statusDetails.addTradePlanTime ?? null;
  }
  return parsedObj;
}
